
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collection/[address]",
      function () {
        return require("private-next-pages/collection/[address]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collection/[address]"])
      });
    }
  